export const LocalStorageProperties = {
    CurrentUserId: 'CurrentUserId',
    CurrentUser: 'CurrentUser',
    CurrentCulture: 'CurrentCulture',
    CompanyId: 'CompanyId',
    CompanyName: 'CompanyName',
    CompanyMainLogo:'CompanyMainLogo',
    CompanyMiniLogo:'CompanyMiniLogo',
    DefaultDashboard: 'DefaultDashboard',
    CompanyDetails: 'CompanyDetails',
    FromLogIn: 'FromLogIn',
    CompanyTheme: 'CompanyTheme',
    SearchClick: 'SearchClick',
    RoleFeatures:'RoleFeatures',
    SoftLabels: 'SoftLabels',
    RecentSearches: 'RecentSearches',
    Dashboards: 'Dashboards',
    ExpensesFileCount: 'ExpensesFilesCount',
    Environment: 'Environment',
    CompanySettings: 'CompanySettings',
    ContactDetails:'ContactDetails',
    UserModel: 'UserModel',
    IsSignalREnabled: 'IsSignalREnabled',
    BackendBasePath:'BackendBasePath',
    TrackerBasePath:'TrackerBasePath',
    SignalRBasePath:'SignalRBasePath',
    HydaSignalRBasePath : 'HydaSignalRBasePath'
}